<template>
  <div>
    <div class="main_box">
      <div class="pay">
        <div class="payMsg">
          <img src="../assets/images/tick.png" />
          <span class="num" style="margin-top:20px;">订单数量&#x3000;1</span>
          <span class="num">商品数量&#x3000;{{Number(orderInfo.quantity)}}</span>
          <span class="money">￥{{allTotal}}</span>
          <span class="explain">
            请及时完成，否则订单将自动取消&#x3000;&#x3000;

          </span>
        </div>

        <div class="orderInformation">
          <div class="orderInformationBox">
            <h2>
              <span style="color:#ffe7ae;">▎</span>订单信息
            </h2>
            <div class="orderInformationSpan">
              <el-table :data="orderInformation" border style="width: 100%">
                <el-table-column prop="merchIndustryName" label="景点" width="180"></el-table-column>
                <el-table-column prop="goodsName" label="产品" width="180"></el-table-column>
                <el-table-column prop="unitPrice" label="单价">
                  <template slot-scope="scope">
                    <span>¥{{scope.row.unitPrice}}</span>
                  </template>
                </el-table-column>
                <el-table-column label="数量" prop="quantity"></el-table-column>
                <el-table-column label="出游时间" prop="useStartDate" width="160"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="packageIncludes">
          <h2 class="title mt40">
            套餐包含
          </h2>
          <div class="includes-body">
            <div v-for="(item ,index) in orderCreatInfo.orderTripCreateList " :key="index">
              <div class="sub-title-line flex-start">
                <img src="../assets/imgs/box.png" alt="">
                <span class="sub-title">{{ item.subGoodsName }} ({{ item.subGoodsTargetName }})</span>
              </div>
              <div class="sub-Goods">
                数量：{{ orderCreatInfo.quantity*item.visitorList.length }}张  <span class="ml40"> 参观时间：{{ orderCreatInfo.useStartDate }}</span>
              </div>
            </div>
            <div v-for="(item ,index) in orderCreatInfo.orderHotelCreateList " :key="'hotel-' + index">
              <div class="sub-title-line flex-start">
                <img src="../assets/imgs/box.png" alt="">
                <span class="sub-title">{{ item.subGoodsName }} ({{ item.subGoodsTargetName }})</span>
              </div>
              <div class="sub-Goods">
                {{  checkOutTime(orderCreatInfo.useStartDate) }}  入住  <span class="ml40"> {{checkOutTime(orderCreatInfo.useStartDate,item.subGoodsTargetQuantity) }} 退房</span><span class="ml40"> 共{{ orderCreatInfo.quantity }}晚</span>
              </div>
            </div>

          </div>
        </div>
        <div class="next">
          <div class="nextBtn" @click="handleNext" v-if="!loading">立即支付</div>
          <div class="nextBtn" v-else>立即支付</div>
        </div>
      </div>
    </div>
    <!-- 支付弹框 -->
    <payDialog ref="payDialog" />
  </div>
</template>

<script>
import { orderInfo } from '@/api/packageTicket/packageTicketBook'
import { formatDate } from '../utils/validate'
import PayDialog from '@/components/payDialog'
export default {
  components: {
    'payDialog': PayDialog
  },
  data () {
    return {
      goodsNum: 0,
      allTotal: 0,
      expireSeconds: null,
      timer: null,
      timer2: null,
      loading: false,
      payConfigId: null,
      orderNo: null,
      orderInfo: {},
      orderInformation: [],
      reservationMsg: '',
      listOrder: null,
      number: 0
    }
  },
  created () {
    this.reservationMsg = this.$route.query.reservationMsg
    this.orderNo = this.$route.query.orderNo
    // this.orderNo = '1446665836468256769'
    this.type = this.$route.query.type || 'spot'
    this.getOrderInfo()
    this.orderCreatInfo = JSON.parse(localStorage.getItem('orderCreatInfo'))
  },
  methods: {
    checkOutTime (date, days = 0) {
      let newDate = formatDate('yyyy-MM-dd', new Date(new Date(date).getTime() + 24 * 60 * 60 * 1000 * days))
      let week = this.getWeekday(new Date(newDate).getDay())
      return newDate.replace('-', '年').replace('-', '月') + '日  ' + week.replace('星期', '周') + '  '
    },
    getWeekday (day) {
      return ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'][day]
    },
    getOrderInfo () {
      orderInfo(this.orderNo).then(res => {
        if (res.code === 0) {
          this.orderInfo = res.data
          let orderInformation = [res.data]
          orderInformation[0].useStartDate = res.data.useDate
          this.orderInformation = orderInformation
          this.allTotal = res.data.paymentTotal.toFixed(2)
        }
      })
    },
    handleNext () {
      this.$refs.payDialog.toPay(this.orderNo, 'PACKAGES')
    },
    toPath (path) {
      this.$router.push(path)
    }
  },
  filters: {
    timeFormat: function (val) {
      const M = parseInt(val / 60)
      const s = parseInt(val % 60)
      return (M < 10 ? '0' + M : M) + '分' + (s < 10 ? '0' + s : s) + '秒'
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.timer2) {
      clearInterval(this.timer2)
    }
  }
}
</script>

<style scoped>
.packageIncludes {
  width: 80%;
  margin: 0 auto 40px;
}
.packageIncludes .title {
  font-size: revert;
}
.packageIncludes .title::before {
  margin-top: 0
}
.ml40 {
  margin-left: 40px;
}
.main_box {
  margin-top: 60px;
}
.orderInformationSpan {
  width: 80%;
  margin: 0 auto;
}
.orderInformation {
  width: 100%;
  margin: 10px 0 30px 0;
}
.orderInformationBox {
  width: 80%;
  margin: 0 auto;
}
.title {
  font-size: 24px;
  line-height: 65px;
  font-weight: bold;
}

.title::before {
  content: "";
  float: left;
  width: 5px;
  height: 28px;
  background-color: #ffe7ae;
  margin-top: 19px;
  margin-right: 10px;
}

.pay {
  position: relative;
  border: 1px solid #ddd;
  margin-bottom: 59px;
  background-color: #fff;
}

.payMsg {
  position: relative;
  height: 155px;
  padding: 20px 30px;
  box-sizing: border-box;
  border-bottom: 2px solid #241008;
}

.payMsg img {
  float: left;
  margin-right: 15px;
}

.payMsg .num {
  float: left;
  width: 600px;
  font-size: 18px;
  margin: 5px 0;
}

.payMsg .proNum {
  float: left;
  width: 600px;
  font-size: 18px;
}

.payMsg .money {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 40px;
  color: #ff6913;
}

.payMsg .explain {
  position: absolute;
  top: 90px;
  right: 30px;
  font-size: 12px;
  font-family: "SimSun";
}

.payWay .tit {
  font-family: "SimSun";
  color: #222;
  padding-left: 18px;
  line-height: 40px;
  background-color: #fafafa;
}

.payment {
  text-align: center;
}

.payment input[type="radio"] {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 10px;
}

.payment label {
  display: inline-block;
  vertical-align: middle;
  margin-right: 40px;
}

.payment label:nth-last-child(1) {
  margin-right: 0px;
}

.Weixin {
  background-image: url(../assets/images/weixin.png);
  width: 147px;
  height: 39px;
}

.AliPay {
  background-image: url(../assets/images/Alipay.png);
  width: 175px;
  height: 41px;
}

.Chinaums {
  background-image: url(../assets/images/Unionpay.png);
  width: 153px;
  height: 33px;
}

.qrCode {
  padding-top: 20px;
  text-align: center;
}

.qrCode .img {
  display: inline-block;
  width: 200px;
  height: 200px;
}

.next {
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #ddd;
  padding: 15px 70px;
  box-sizing: border-box;
  text-align: right;
}

.nextBtn {
  display: inline-block;
  width: 130px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #241008;
  color: #fff;
  font-family: "SimSun";
  font-size: 14px;
  cursor: pointer;
}
.nextBtn:hover {
  opacity: 0.9;
}
.timeout {
  display: inline-block;
  padding: 100px 0;
  text-align: center;
  width: 100%;
}
.gobuy {
  cursor: pointer;
}
.payway-list {
  vertical-align: middle;
  margin-bottom: 70px;
  margin-right: 30px;
  margin-top: 20px;
  display: inline-block;
  min-width: 180px;
  cursor: pointer;
}
.payway-list img {
  display: inline-block;
  width: 220px;
}
.payway-list label {
  border-left: 1px solid #f3f3f3;
  padding-left: 10px;
}
.left-icon {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 60px;
}
.left-icon-imagbox {
  position: absolute;
  width: 156px;
  top: 25px;
  left: 0;
}
.left-icon-imagbox-item {
  display: inline-block;
  margin-right: 8px;
}
.left-icon-imagbox-item p {
  font-size: 10px;
}
.left-icon-imagbox-item2 {
  margin-left: 8px;
}
.left-icon-imagbox-item-left {
  border: 1px solid #f6f6f6;
  height: 20px;
  position: absolute;
  top: 20px;
}
.left-icon img {
  width: 60px;
  height: 60px;
}
</style>
